"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataChangeHistoryApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("./ApiBase");
const SystemRedux_1 = require("../../Redux/ActionsReducers/SystemRedux");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
class DataChangeHistoryApiImpl extends ApiBase_1.ApiBase {
    getDataChangeHistoryMode() {
        return this.getAdaptableState().System.DataChangeHistory.currentMode;
    }
    activateDataChangeHistory(forceReset) {
        const currentMode = this.getDataChangeHistoryMode();
        if (currentMode === 'ACTIVE' && !forceReset) {
            return;
        }
        if (forceReset || currentMode === 'INACTIVE') {
            this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistoryEnable)());
        }
        else if (currentMode === 'SUSPENDED') {
            this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistoryResume)());
        }
    }
    deactivateDataChangeHistory() {
        if (this.getDataChangeHistoryMode() === 'ACTIVE' ||
            this.getDataChangeHistoryMode() === 'SUSPENDED') {
            this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistoryDisable)());
        }
    }
    suspendDataChangeHistory() {
        if (this.getDataChangeHistoryMode() === 'ACTIVE') {
            this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistorySuspend)());
        }
    }
    getDataChangeHistoryLog() {
        var _a;
        const changeLog = (_a = this.getAdaptableState().System.DataChangeHistory.logs) !== null && _a !== void 0 ? _a : {};
        return Object.values(changeLog);
    }
    undoDataChangeHistoryEntry(dataChangeInfo) {
        this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistoryUndo)(dataChangeInfo));
    }
    clearDataChangeHistoryEntry(dataChangeInfo) {
        this.dispatchAction((0, SystemRedux_1.SystemDataChangeHistoryClearRow)(dataChangeInfo));
    }
    openDataChangeHistorySettingsPanel() {
        this.showModulePopup(ModuleConstants.DataChangeHistoryModuleId);
    }
}
exports.DataChangeHistoryApiImpl = DataChangeHistoryApiImpl;
